import { supabase } from '../utils/supabase';
import { Store } from '../types';

export interface StoreService {
  getStores: () => Promise<{ data: Store[] | null; error: any }>;
  getActiveStoresCount: () => Promise<{ data: number | null; error: any }>;
}

export const storeService: StoreService = {
  // Get all active stores using RPC
  getStores: async () => {
    // Return mock data if Supabase is not configured
    if (!supabase) {
      console.warn('Supabase not configured, using mock data');
      return { data: mockStores, error: 'Supabase not configured' };
    }

    try {
      const { data, error } = await supabase
        .rpc('get_stores');

      if (error) {
        console.error('Error fetching stores:', error);
        return { data: null, error };
      }

      return { data: data || [], error: null };
    } catch (error) {
      console.error('Error calling get_stores RPC:', error);
      return { data: null, error };
    }
  },

  // Get count of active stores
  getActiveStoresCount: async () => {
    // Return mock count if Supabase is not configured
    if (!supabase) {
      console.warn('Supabase not configured, using mock data');
      return { data: mockStores.length, error: 'Supabase not configured' };
    }

    try {
      const { data, error } = await supabase
        .rpc('get_active_stores_count');

      if (error) {
        console.error('Error fetching store count:', error);
        return { data: null, error };
      }

      return { data: data || 0, error: null };
    } catch (error) {
      console.error('Error calling get_active_stores_count RPC:', error);
      return { data: null, error };
    }
  }
};

// Fallback mock data for development/testing - Using real UUIDs from database
export const mockStores: Store[] = [
  {
    id: '59650b2a-3cd2-463f-b9cb-064c66f486f7',
    name: 'Skin Culture',
    code: 'SKINCULTURE',
    address: 'Main Store Location',
    phone: '+960 123-4567',
    email: 'skinculture@beautello.mv',
    is_active: true,
    store_type: 'physical',
    manager_name: 'Store Manager',
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: '4884a032-843d-47d7-b447-3bd499fe4199',
    name: 'Beautello',
    code: 'BEAUTELLO',
    address: 'Secondary Store Location',
    phone: '+960 234-5678',
    email: 'beautello@beautello.mv',
    is_active: true,
    store_type: 'physical',
    manager_name: 'Assistant Manager',
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: '8fc55ef2-a5b1-4a65-9bbb-996ae4212f32',
    name: 'Rawbeauty',
    code: 'RAWBEAUTY',
    address: 'Rawbeauty Store Location',
    phone: '+960 345-6789',
    email: 'rawbeauty@beautello.mv',
    is_active: true,
    store_type: 'physical',
    manager_name: 'Store Manager',
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  }
];